import Api from "./api";

class TariffAPI {
    api = new Api()

    getDefault() {
        return this.api.get('/tariffs/default')
    }

    getCurrent() {
        return this.api.get('/tariffs/current')
    }
    /**
     * Получение лимитов пользователя
     */
    getLimits() {
        return this.api.get('/limits/all')
    }
}

export default new TariffAPI();
